import React, { FC, useCallback, useEffect, useReducer, useState } from 'react';

import { Alert, AlertIcon, Box } from '@chakra-ui/react';
import { find, isEmpty, replace } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { IdentityProviderName } from 'api/auth/api.pb';
import { Form } from 'components/DataEntry';
import { selectUser } from 'containers/App/selectors';
import { selectIntegrations } from 'containers/Setup/Integrations/selectors';
import { actions } from 'containers/Setup/Integrations/slice';
import { formStyles } from 'containers/Setup/Integrations/styles';

interface ISSOAddProvider {}

export const SSOAddProvider: FC<ISSOAddProvider> = props => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams<{
    provider: string;
  }>();
  const { info } = useSelector(selectUser);
  const { sso } = useSelector(selectIntegrations);
  const { providerNames, providerForm } = sso;
  const { createProvider } = providerForm;
  const [state, updateState] = useReducer(
    (prev, next) => {
      return { ...prev, ...next };
    },
    {
      providerConfig: {},
      error: '',
      configUri: '',
    },
  );

  const [url] = useState(new URL(window.location.origin));

  const resetError = useCallback(() => {
    dispatch(actions.resetProviderNamesError());
    dispatch(actions.resetCreateSSOProviderError());
  }, [dispatch]);

  useEffect(() => {
    dispatch(actions.getProviderNames());
    return () => resetError();
  }, [dispatch, resetError]);

  const onCancel = () => {
    resetError();
    navigate('/setup/integrations');
  };

  useEffect(() => {
    if (!isEmpty(providerNames.data))
      updateState({
        providerConfig: find(
          providerNames.data,
          o => o.provider === params.provider,
        )!,
      });
  }, [providerNames.data, params.provider]);

  useEffect(() => {
    console.log(createProvider.error);
    if (!!createProvider.error || !!providerNames.error)
      updateState({ error: createProvider.error ?? providerNames.error });
  }, [createProvider.error, providerNames.error]);

  const handleSubmit = data => {
    const {
      client_id = '',
      client_secret = '',
      config_uri = '',
      tenant_id = '',
    } = data;
    const payload = {
      provider: params?.provider as IdentityProviderName,
      config: { client_id, client_secret, config_uri: '', tenant_id },
      organization: info.org_id,
      enabled: true,
      onRedirect: onCancel,
    };

    if (params?.provider === 'Okta') {
      payload.config.config_uri = config_uri;
    }

    dispatch(actions.createSSOProvider(payload));
  };

  return (
    <Form
      isLoading={providerNames.loading}
      schema={{
        /*provider: {
          type: 'text',
          label: 'Provider Name',
          value: providerConfig?.provider,
          isRequired: true,
          isDisabled: true,
        },*/
        signInRedirectURL: {
          type: 'text',
          label: 'Sign-in Redirect URI',
          value: `${url.protocol}//${url.host}${state.providerConfig?.redirect_uri}`,
          isDisabled: true,
          showCopy: true,
        },

        ...(params?.provider === IdentityProviderName.Okta
          ? {
              signOutRedirectURL: {
                type: 'text',
                label: 'Sign-out Redirect URI',
                value: `${url.protocol}//${url.host}${state.providerConfig?.redirect_uri}/logout_response`,
                isDisabled: true,
                showCopy: true,
              },
              config_uri: {
                type: 'text',
                label: 'Config URI',
                isRequired: true,
                value: state.configUri,
                onChange: val =>
                  updateState({
                    configUri: val /*replace(
                      replace(val, 'https://', ''),
                      'http://',
                      '',
                    )*/,
                    error: '',
                  }),
                autoFocus: true,
                /*onKeyDown: val =>
                  setConfigUri(
                    val,
                    //replace(replace(val, 'https://', ''), 'http://', ''),
                  ),*/
              },
            }
          : null),
        client_id: {
          type: 'text',
          label: 'Client ID',
          isRequired: true,
          onChange: () => updateState({ error: '' }),
          autoFocus: params?.provider !== IdentityProviderName.Okta,
        },
        client_secret: {
          type: 'text',
          label: 'Client Secret',
          isRequired: true,
          htmlInputType: 'password',
          passwordShow: true,
          onChange: () => updateState({ error: '' }),
        },
        ...(params?.provider === IdentityProviderName.Microsoft
          ? {
              tenant_id: {
                type: 'text',
                label: 'Tenant ID',
                onChange: () => updateState({ error: '' }),
              },
            }
          : null),
        ...(!!state.error
          ? {
              validatedMessage: {
                type: 'custom',
                component: () => {
                  return (
                    <Box w="full">
                      <Alert
                        status={'error'}
                        borderRadius={6}
                        // title={
                        //   'Failed to ' +
                        //   (providerNames.error
                        //     ? 'get provider config.'
                        //     : 'add ' + params?.provider + ' SSO.')
                        // }
                      >
                        <AlertIcon />
                        {state.error}
                      </Alert>
                    </Box>
                  );
                },
              },
            }
          : {}),
      }}
      showHelp
      styles={formStyles}
      buttonOptions={{
        submit: {
          name: 'ENABLE',
          isLoading: createProvider?.loading,
          isDisabled: createProvider?.loading,
        },
        reset: {
          isVisible: true,
          isDisabled: createProvider?.loading,
          onClick: onCancel,
        },
      }}
      handleSubmit={handleSubmit}
    />
  );
};
